import React, { useState } from 'react';
import { Gift } from 'lucide-react';
import GiftModal from './GiftModal';

const Header = ({ packages = [] }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isGiftModalOpen, setIsGiftModalOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80; // Height of the header
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  const handleSignUp = () => {
    console.log('Signed up');
  };

  const navigationItems = [
    { id: 'about', label: 'About' },
    { id: 'services', label: 'Programs & Services' },
    { id: 'testimonials', label: 'Testimonials' },
    { id: 'blog', label: 'Blog' },
    { id: 'newsletter', label: 'Newsletter' }
  ];

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-lg border-b border-purple-100 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <a href="/ht_phyt" className="flex-shrink-0 group">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <span className="text-white font-bold text-xl">P</span>
                </div>
                <span className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                  THE PHYT GYM
                </span>
              </div>
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              {navigationItems.map((item) => (
                <button 
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-gray-700 hover:text-purple-600 font-medium transition-all duration-300 relative group"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-500 to-pink-500 group-hover:w-full transition-all duration-300"></span>
                </button>
              ))}
              <div className="flex items-center space-x-4">
                <button 
                  onClick={() => setIsGiftModalOpen(true)}
                  className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-6 py-2 rounded-xl font-medium hover:from-pink-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-lg relative overflow-hidden group flex items-center space-x-2"
                >
                  <Gift size={18} />
                  <span className="relative z-10">Gift</span>
                  <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                </button>
                <button 
                  onClick={() => scrollToSection('booking')}
                  className="bg-gradient-to-r from-purple-600 to-purple-800 text-white px-6 py-2 rounded-xl font-medium hover:from-purple-700 hover:to-purple-900 transition-all duration-300 transform hover:scale-105 hover:shadow-lg relative overflow-hidden group"
                >
                  <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                  <span className="relative z-10">Book Session</span>
                </button>
                <div className="relative flex items-center">
                  <button 
                    onClick={handleSignUp}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    className="bg-white border-2 border-purple-600 text-purple-600 px-6 py-2 rounded-xl font-medium hover:bg-purple-50 transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
                  >
                    Sign Up
                  </button>
                  {/* Tooltip below the button */}
                  <div className={`absolute left-1/2 top-full mt-2 transform -translate-x-1/2 z-50 transition-opacity duration-200 ${showTooltip ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
                    <div className="bg-purple-600 text-white text-xs rounded-md px-3 py-2 shadow-lg flex items-center min-w-max relative">
                      More about joining the exclusive community
                      <span className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-purple-600"></span>
                    </div>
                  </div>
                </div>

              </div>
            </nav>

            {/* Mobile Navigation Button */}
            <button 
              className="md:hidden flex flex-col justify-center items-center w-8 h-8 group"
              onClick={toggleMenu}
            >
              <span className={`block w-6 h-0.5 bg-purple-600 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
              <span className={`block w-6 h-0.5 bg-purple-600 my-1.5 transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block w-6 h-0.5 bg-purple-600 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
            </button>
          </div>

          {/* Mobile Menu */}
          <div className={`md:hidden transition-all duration-300 ease-in-out ${
            isMenuOpen 
              ? 'max-h-screen opacity-100' 
              : 'max-h-0 opacity-0 pointer-events-none'
          } overflow-hidden bg-gradient-to-br from-purple-50 to-pink-50 rounded-b-2xl border-t border-purple-100 mt-1`} style={{ maxHeight: isMenuOpen ? '100vh' : 0 }}>
            <div className="px-4 py-6 space-y-4">
              {navigationItems.map((item) => (
                <button 
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block w-full text-left text-gray-700 hover:text-purple-600 font-medium py-3 px-4 rounded-xl hover:bg-purple-100 transition-all duration-300 transform hover:translate-x-2"
                >
                  {item.label}
                </button>
              ))}
              <div className="space-y-3">
                <button 
                  onClick={() => setIsGiftModalOpen(true)}
                  className="w-full bg-gradient-to-r from-pink-500 to-purple-600 text-white px-6 py-3 rounded-xl font-medium hover:from-pink-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-[1.02] shadow-lg hover:shadow-xl flex items-center justify-center space-x-2"
                >
                  <Gift size={18} />
                  <span>Gift Package</span>
                </button>
                <button 
                  onClick={() => scrollToSection('booking')}
                  className="w-full bg-gradient-to-r from-purple-600 to-purple-800 text-white px-6 py-3 rounded-xl font-medium hover:from-purple-700 hover:to-purple-900 transition-all duration-300 transform hover:scale-[1.02] shadow-lg hover:shadow-xl"
                >
                  Book Session
                </button>
                <div className="relative w-full flex justify-center">
                  <button 
                    onClick={handleSignUp}
                    onTouchStart={() => setShowTooltip(true)}
                    onTouchEnd={() => setShowTooltip(false)}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    className="w-full bg-white border-2 border-purple-600 text-purple-600 px-6 py-3 rounded-xl font-medium hover:bg-purple-50 transition-all duration-300 transform hover:scale-[1.02] shadow-lg"
                  >
                    Sign Up
                  </button>
                  {/* Tooltip below the button */}
                  <div className={`absolute left-1/2 top-full mt-2 transform -translate-x-1/2 z-50 transition-opacity duration-200 ${showTooltip ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
                    <div className="bg-purple-600 text-white text-xs rounded-md px-3 py-2 shadow-lg flex items-center min-w-max relative">
                      More about joining the exclusive community
                      <span className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-purple-600"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Custom Styles */}
        <style>{`
          /* Smooth backdrop blur effect */
          .backdrop-blur-md {
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
          }
          
          /* Ensure mobile menu animations work smoothly */
          @media (max-width: 768px) {
            .max-h-96 {
              max-height: 24rem;
            }
            
            .max-h-0 {
              max-height: 0;
            }
          }
        `}</style>
      </header>

      {/* Gift Modal */}
      <GiftModal 
        isOpen={isGiftModalOpen} 
        onClose={() => setIsGiftModalOpen(false)} 
      />
    </>
  );
};

export default Header;